const MuiTableCell: object = {
  root: {
    borderBottom: "solid 1px #dee2e6",
  },
};

export default MuiTableCell;
